import * as z from "zod/v4";

export const deleteCampaign = {
  name: "deleteCampaign" as const,
  input: z.object({ id: z.string() }),
  output: z.null(),
};
